module.exports = __webpack_public_path__ + "static/media/shopware.d7374eae.svg";